import { render, staticRenderFns } from "./BaseFormCard.vue?vue&type=template&id=0453e35e&scoped=true&"
import script from "./BaseFormCard.vue?vue&type=script&lang=js&"
export * from "./BaseFormCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormCard.vue?vue&type=style&index=0&id=0453e35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453e35e",
  null
  
)

export default component.exports